import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ModalChangePasswordService } from '../../core/modal-change-password/modal-change-password.service';
import { ChangePassword, User } from '../../core/models/user';
import { ToasterService } from '../../core/toastr/toaster.service';
import { UserService } from '../../core/services/user.service';
declare var bootstrap: any;

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrl: './userprofile.component.css'
})
export class UserprofileComponent implements OnInit {

  @ViewChild('modalChangePassword', { static: false }) modalChangePassword!: ElementRef;

  // Properties untuk nilai password
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';

  // Properties untuk toggle visibility
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  // Properties untuk loading state
  isLoading: boolean = false;

  itemCurrentUser: User = {} as User;
  itemPicture: string = "";
  private toastrService = inject(ToasterService);
  private modalInstance: any;

  constructor(
    private modalPasswordService: ModalChangePasswordService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const userData = localStorage.getItem('currentUser');
    this.itemCurrentUser = userData ? JSON.parse(userData) : {} as User;
    this.itemPicture = (this.itemCurrentUser.picture && this.itemCurrentUser.picture.trim() !== '')
      ? this.itemCurrentUser.picture
      : 'assets/images/default-user-profile.png';

    // console.log('Current User Data:', this.itemCurrentUser.picture);
  }

  ngAfterViewInit(): void {
    // Initialize Bootstrap modal instance
    if (this.modalChangePassword) {
      this.modalInstance = new bootstrap.Modal(this.modalChangePassword.nativeElement, {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  // Methods untuk toggle visibility
  toggleCurrentPasswordVisibility(): void {
    this.showCurrentPassword = !this.showCurrentPassword;
  }

  toggleNewPasswordVisibility(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Validasi input password
  private validatePasswords(): boolean {
    // Cek apakah semua field sudah diisi
    if (!this.currentPassword.trim()) {
      this.toastrService.error('Validation Error', 'Current password is required');
      return false;
    }

    if (!this.newPassword.trim()) {
      this.toastrService.error('Validation Error', 'New password is required');
      return false;
    }

    if (!this.confirmPassword.trim()) {
      this.toastrService.error('Validation Error', 'Confirm password is required');
      return false;
    }

    // Cek apakah new password dan confirm password sama
    if (this.newPassword !== this.confirmPassword) {
      this.toastrService.error('Validation Error', 'New Password and Confirm Password do not match');
      return false;
    }

    // Cek panjang password minimal
    if (this.newPassword.length < 6) {
      this.toastrService.error('Validation Error', 'New password must be at least 6 characters long');
      return false;
    }

    // Cek apakah current password dan new password berbeda
    if (this.currentPassword === this.newPassword) {
      this.toastrService.error('Validation Error', 'New password must be different from current password');
      return false;
    }

    return true;
  }

  // Method untuk memproses perubahan password
  changePassword(): void {

    // Validasi input
    if (!this.validatePasswords()) {
      return;
    }

    // Set loading state
    this.isLoading = true;

    // Prepare data untuk API
    const passwordData: ChangePassword = {
      current_password: this.currentPassword,
      new_password: this.newPassword,
      new_password_confirm: this.confirmPassword
    };

    // Panggil API
    this.userService.changePassword(passwordData).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.closeModal();

        if (response.success) {
          // Reset form dan tutup modal
          this.resetForm();
          this.closeModal();

          // Tampilkan success message setelah modal tertutup
          setTimeout(() => {
            this.toastrService.success('success', response.message);
          }, 300);

          // Tampilkan modal success jika diperlukan
          setTimeout(() => {
            this.modalPasswordService.openModal();
          }, 800);

        } else {
          // API mengembalikan success: false
          this.toastrService.error('Change Password Gagal', response.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Change password error:', error);

        // Handle berbagai jenis error
        if (error.status === 400) {
          this.toastrService.error('Change Password Gagal', error.message);
        } else if (error.status === 401) {
          this.toastrService.error('Change Password Gagal', error.message);
        } else if (error.status === 422) {
          this.toastrService.error('Change Password Gagal', error.message);
        } else if (error.status === 500) {
          this.toastrService.error('Change Password Gagal', error.message);
        } else {
          this.toastrService.error('Change Password Gagal', error.message);
        }
      }
    });
  }

  // Method untuk menutup modal - Updated dengan multiple approaches
  private closeModal(): void {
    try {
      // Method 1: Menggunakan ViewChild modal instance
      if (this.modalInstance) {
        this.modalInstance.hide();
        return;
      }

      // Method 2: Menggunakan Bootstrap Modal API langsung
      const modalElement = document.getElementById('modalInputChangePassword');
      if (modalElement && typeof bootstrap !== 'undefined') {
        const modalInstance = bootstrap.Modal.getInstance(modalElement) ||
          new bootstrap.Modal(modalElement);
        modalInstance.hide();
        return;
      }

      // Method 3: Menggunakan jQuery jika tersedia
      if (typeof (window as any).$ !== 'undefined') {
        (window as any).$('#modalInputChangePassword').modal('hide');
        return;
      }

      // Method 4: Fallback menggunakan close button
      this.clickCloseButton();

    } catch (error) {
      console.error('Error closing modal:', error);
      // Fallback terakhir
      this.clickCloseButton();
    }
  }

  // Helper method untuk click close button
  private clickCloseButton(): void {
    setTimeout(() => {
      const closeButton = document.getElementById('btnCloseChangePassword');
      if (closeButton) {
        closeButton.click();
      }
    }, 100);
  }

  // Method untuk reset form
  private resetForm(): void {
    this.currentPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
    this.showCurrentPassword = false;
    this.showNewPassword = false;
    this.showConfirmPassword = false;
  }

  // Method yang dipanggil saat tombol Save diklik
  showPasswordModal(): void {
    this.changePassword();
  }

  // Method untuk membuka modal (jika diperlukan)
  openModal(): void {
    if (this.modalInstance) {
      this.modalInstance.show();
    }
  }
}
